import type {ThemeConfig} from 'antd';
import {BORDER_RADIUS, COLORS, COMPONENT_SIZE, MOTION, SHADOWS, SPACING, TYPOGRAPHY} from "./constants";

const themeConfig: ThemeConfig = {
        token: {
                // colorPrimary: COLORS.colorPrimary,
            //     colorInfo: COLORS.colorInfo,
            //     colorSuccess: COLORS.colorSuccess,
            //     colorWarning: COLORS.colorWarning,
            //     colorError: COLORS.colorError,
            //
            //
            //     colorBgBase: COLORS.colorBgBase,
            //     colorBgContainer: COLORS.colorBgContainer,
            //     colorBgElevated: COLORS.colorBgElevated,
            //     colorBgLayout: COLORS.colorBgLayout,
            //
            //     colorText: COLORS.colorText,
            //     colorTextSecondary: COLORS.colorTextSecondary,
            //     colorTextTertiary: COLORS.colorTextTertiary,
            //     colorTextQuaternary: COLORS.colorTextQuaternary,
            //
            //     colorBorder: COLORS.colorBorder,
            //     colorBorderSecondary: COLORS.colorBorderSecondary,
            //
            //     borderRadius: BORDER_RADIUS.borderRadius,
            //     borderRadiusLG: BORDER_RADIUS.borderRadiusLG,
            //     borderRadiusSM: BORDER_RADIUS.borderRadiusSM,
            //     borderRadiusXS: BORDER_RADIUS.borderRadiusXS,
            //
            //     fontFamily: TYPOGRAPHY.fontFamily,
            //     fontSize: TYPOGRAPHY.fontSize,
            //     fontSizeLG: TYPOGRAPHY.fontSizeLG,
            //     fontSizeSM: TYPOGRAPHY.fontSizeSM,
            //     fontSizeXL: TYPOGRAPHY.fontSizeXL,
            //     fontSizeHeading1: TYPOGRAPHY.fontSizeHeading1,
            //     fontSizeHeading2: TYPOGRAPHY.fontSizeHeading2,
            //     fontSizeHeading3: TYPOGRAPHY.fontSizeHeading3,
            //     fontSizeHeading4: TYPOGRAPHY.fontSizeHeading4,
            //     fontSizeHeading5: TYPOGRAPHY.fontSizeHeading5,
            //
            //     padding: SPACING.padding,
            //     paddingLG: SPACING.paddingLG,
            //     paddingSM: SPACING.paddingSM,
            //     paddingXS: SPACING.paddingXS,
            //     paddingXL: SPACING.paddingXL,
            //
            //     controlHeight: COMPONENT_SIZE.controlHeightSM,
            //     controlHeightLG: COMPONENT_SIZE.controlHeightLG,
            //     controlHeightSM: COMPONENT_SIZE.controlHeightSM,
            //
            //     boxShadow: SHADOWS.boxShadow,
            //     boxShadowSecondary: SHADOWS.boxShadowSecondary,
            //     boxShadowTertiary: SHADOWS.boxShadowTertiary,
            //
            //     motionDurationFast: MOTION.motionDurationFast,
            //     motionDurationMid: MOTION.motionDurationMid,
            //     motionDurationSlow: MOTION.motionDurationSlow,
        },
        components: {
            //     Button: {
            //         colorPrimary: COLORS.colorPrimary,
            //         colorPrimaryHover: COLORS.colorPrimaryHover,
            //         colorPrimaryActive: COLORS.colorPrimaryActive,
            //         borderRadius: BORDER_RADIUS.borderRadius,
            //         controlHeight: COMPONENT_SIZE.controlHeightSM,
            //         fontWeight: 500,
            //         primaryShadow: 'none',
            //     },
            //
            //     Card: {
            //         borderRadiusLG: BORDER_RADIUS.borderRadius,
            //         boxShadowTertiary: SHADOWS.boxShadow,
            //         headerBg: COLORS.colorBgContainer,
            //         colorBorderSecondary: COLORS.colorBorderSecondary,
            //     },
            //
            //     Table: {
            //         headerBg: '#fafafa',
            //         headerColor: COLORS.colorTextSecondary,
            //         borderColor: COLORS.colorBorderSecondary,
            //         rowHoverBg: '#fafafa',
            //         borderRadius: BORDER_RADIUS.borderRadius,
            //     },
            //
            //     Tag: {
            //         borderRadiusSM: BORDER_RADIUS.borderRadiusSM,
            //     },
            //
            //     Alert: {
            //         borderRadiusLG: BORDER_RADIUS.borderRadiusLG,
            //         fontSizeLG: TYPOGRAPHY.fontSize,
            //     },
            //
            //     Input: {
            //         borderRadius: BORDER_RADIUS.borderRadius,
            //         controlHeight: COMPONENT_SIZE.controlHeightSM,
            //         paddingInline: SPACING.paddingSM,
            //         colorBgContainer: COLORS.colorBgInput,
            //         colorBorder: COLORS.colorBgInput,
            //         activeBorderColor: COLORS.colorBgInput,
            //     },
            //
            //
            //     Select: {
            //         borderRadius: BORDER_RADIUS.borderRadius,
            //         controlHeight: COMPONENT_SIZE.controlHeight,
            //     },
            //
            //     Modal: {
            //         borderRadiusLG: BORDER_RADIUS.borderRadiusLG,
            //         boxShadow: SHADOWS.boxShadowTertiary,
            //     },
            //
            //
            //     Drawer: {
            //         borderRadiusLG: BORDER_RADIUS.borderRadiusLG,
            //     },
            //
            //     Statistic: {
            //         titleFontSize: TYPOGRAPHY.fontSizeSM,
            //         contentFontSize: TYPOGRAPHY.fontSizeXL,
            //         fontFamily: TYPOGRAPHY.fontFamily,
            //     },
            //
            //     Typography: {
            //         titleMarginBottom: SPACING.paddingSM,
            //         titleMarginTop: 0,
            //         fontFamily: TYPOGRAPHY.fontFamily,
            //     },
            //
            Layout: {
                headerBg: COLORS.colorBgContainer,
                siderBg: COLORS.colorBgPrimary,
                triggerBg: COLORS.colorBgPrimary
            },
            //
            //     Menu: {
            //         itemBg: 'transparent',
            //         itemSelectedBg: COLORS.colorPrimary,
            //         itemSelectedColor: '#ffffff',
            //         itemHoverBg: 'rgba(105, 118, 235, 0.1)',
            //         itemHoverColor: COLORS.colorBgBase,
            //         itemColor: COLORS.colorBgBase,
            //         iconSize: 16,
            //         itemHeight: 42,
            //         itemBorderRadius: BORDER_RADIUS.borderRadius,
            //     },
            //     Form: {
            //         verticalLabelPadding: 0
            //     },
            //     Breadcrumb: {
            //         linkHoverColor: COLORS.colorSecondary
            //     },
            //     Segmented: {
            //         trackBg: COLORS.colorBgInput,
        }

    };

export default themeConfig;





